export default __webpack_public_path__ + "static/pattern-01-5797423651df97c30bd6a7822f97cda2.png";